require.register("app/restaurant/analyse/invoice/CreateModal", function(exports, require, module){
  $0
  
});

